import { render, staticRenderFns } from "./CompOpcoesPesquisaMontarProcessos.vue?vue&type=template&id=b1464c94&"
import script from "./CompOpcoesPesquisaMontarProcessos.vue?vue&type=script&lang=js&"
export * from "./CompOpcoesPesquisaMontarProcessos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports